import { Flex, Heading } from '@chakra-ui/react';
import React from 'react';
import DocumentsTable from '../components/DocumentTable';

const Documente = () => {   
  return (
    <>
      <DocumentsTable />
    </>
  );
};

export default Documente;
